import LanguageTag from '../../utils/LanguageTag';
import firstDaysByCountry from '../data/firstDayOfWeek.json';
import {getObjectKeyOfLength, isEmptyObject} from './Objects';
import {getDefaultLabels, getLocaleDateStrings} from './Labels';
import {applyLocaleSpecificCapitalizationForDays} from './Labels';

// Some locales have a different day than sunday as the start of week.
// Defaults the first day of week by comparing UTC day of week to
// locale-specific day of week. This default will only be used if init
// is not invoked to initialize based on a locale.
const _firstDayDate = new Date(2000, 0, 3);
const DEFAULT_FIRST_DAY = _firstDayDate.getDay() - _firstDayDate.getUTCDay();

let _instances = {};

function rotateArray(array, offset) {
    return [...array.slice(offset), ...array.slice(0, offset)];
}

// eslint-disable-next-line complexity
function DayNames(languageTag, labels) {
    // Determine the first day of week offset from Sunday (0) for the specified
    // country code. If the country code is not specified or is not recognized,
    // use the default JS API calculated first day.
    const dayOffset =
        languageTag && languageTag.region
            ? Number(firstDaysByCountry[languageTag.region])
            : DEFAULT_FIRST_DAY;
    const locale = languageTag.code;

    // Make sure that dayOffset is not NaN by comparing with itself.
    this.dayOffset = dayOffset !== dayOffset ? DEFAULT_FIRST_DAY : dayOffset; // eslint-disable-line no-self-compare

    this.longDayNames =
        getObjectKeyOfLength(labels, 'longDayNames', 7) ||
        getLocaleDateStrings(locale, {weekday: 'long'}, false) ||
        getDefaultLabels('longDayNames') ||
        [];
    this.dayNames =
        getObjectKeyOfLength(labels, 'dayNames', 7) ||
        getLocaleDateStrings(locale, {weekday: 'short'}, false) ||
        getDefaultLabels('dayNames') ||
        [];
    this.shortDayNames =
        getObjectKeyOfLength(labels, 'shortDayNames', 7) ||
        getLocaleDateStrings(locale, {weekday: 'narrow'}, false) ||
        getDefaultLabels('shortDayNames') ||
        [];
    const dayNameLabels = this.longDayNames;

    this.dayLabels =
        dayNameLabels &&
        dayNameLabels.map((label) =>
            applyLocaleSpecificCapitalizationForDays(label, locale)
        );

    this.shortDayNamesForExperiment =
        this.dayLabels && this.dayLabels.map((label) => label.substring(0, 2));

    if (this.dayOffset) {
        this.longDayNames = rotateArray(this.longDayNames, this.dayOffset);
        this.dayNames = rotateArray(this.dayNames, this.dayOffset);
        this.shortDayNames = rotateArray(this.shortDayNames, this.dayOffset);
        this.shortDayNamesForExperiment = rotateArray(
            this.shortDayNamesForExperiment,
            this.dayOffset
        );
    }
}

DayNames.prototype.getLongDayNames = function () {
    return this.longDayNames;
};

DayNames.prototype.getDayNames = function () {
    return this.dayNames;
};

DayNames.prototype.getShortDayNames = function () {
    return this.shortDayNames;
};

DayNames.prototype.getShortDayNamesForExperiment = function () {
    return this.shortDayNamesForExperiment;
};

DayNames.prototype.getStartOfWeek = function () {
    return this.dayOffset;
};

function getDayNamesInstance(locale, labels) {
    const languageTag = locale ? new LanguageTag(locale) : {};
    const code = languageTag.code;

    labels = labels || {};

    if (!isEmptyObject(labels)) {
        return new DayNames(languageTag, labels);
    }

    if (!_instances[code]) {
        _instances[code] = new DayNames(languageTag, labels);
    }

    return _instances[code];
}

export {getDayNamesInstance, rotateArray};
